import { render, staticRenderFns } from "./BCList.vue?vue&type=template&id=19e4fa38&scoped=true"
import script from "./BCList.vue?vue&type=script&lang=js"
export * from "./BCList.vue?vue&type=script&lang=js"
import style0 from "./BCList.vue?vue&type=style&index=0&id=19e4fa38&scoped=true&lang=scss"
import style1 from "./BCList.vue?vue&type=style&index=1&id=19e4fa38&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4fa38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e4fa38')) {
      api.createRecord('19e4fa38', component.options)
    } else {
      api.reload('19e4fa38', component.options)
    }
    module.hot.accept("./BCList.vue?vue&type=template&id=19e4fa38&scoped=true", function () {
      api.rerender('19e4fa38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/BCManage/BCList.vue"
export default component.exports